module.exports = {"520525001":"雍熙街道","520525002":"文昌街道","520525003":"居仁街道","520525004":"宣慰街道","520525005":"利园街道","520525006":"珙桐街道","520525101":"中岭镇","520525102":"阳长镇","520525103":"维新镇","520525104":"龙场镇","520525105":"乐治镇","520525107":"百兴镇","520525108":"张家湾镇","520525114":"勺窝镇","520525115":"寨乐镇","520525116":"玉龙坝镇","520525117":"沙包镇","520525118":"水东镇","520525119":"曙光镇","520525201":"新房彝族苗族乡","520525202":"厍东关彝族白族苗族乡","520525203":"董地苗族彝族乡","520525205":"化作苗族彝族乡","520525210":"姑开苗族彝族乡","520525211":"羊场苗族彝族乡","520525212":"锅圈岩苗族彝族乡","520525213":"昆寨苗族彝族白族乡","520525214":"左鸠戛彝族苗族乡","520525215":"猪场苗族彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520525.json
// module id = 2621
// module chunks = 0